import axios from 'axios'

class UpdateToken {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @author Pedro Ramos
     * @description Update token in localStorage
     * @date 24/11/2022
     * @param {String} email
     * @param {String} password
     * @returns {Object}
     * @memberof UpdateToken
    */
    async updateToken(email, token) {
        let response = axios.post(`${this.apiUrl}/session-refresh`,
            {
                email: email
            },
            {
                headers:
                {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    }
}

export { UpdateToken as default }